import React, { lazy, Suspense, useEffect, useLayoutEffect, useState } from 'react';
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { initializeApp } from "firebase/app";
import { useSelector, useDispatch } from "react-redux";
import { BrowserRouter, Route, Routes } from 'react-router-dom';
// import _ from 'lodash';
// import { Spinner } from "./components/common";
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAnalytics, logEvent } from 'firebase/analytics';
// import { fetchPictures } from './actions/LaunchActions';

//file imports
import './App.css';


// import Login from './components/launch/Login';
// import Topbars from './components/navigation/Topbars';
// import Home from './components/home/Home';
// import About from './components/about/About';
// import Projects from './components/projects/Projects';
// import Staff from './components/staff/Staff';
// import Contact from './components/contact/Contact';
// import Footer from './components/footer/Footer';
// import Services from './components/services/Services';
// import ProjectDetails from './components/projects/ProjectDetails';
// import StaffProfile from './components/staff/StaffProfile';
// import NotFound from './components/notFound/NotFound';
// import Picture from './components/picture/Picture';
// import PrivacyPolicy from './components/privacyPolicy/PrivacyPolicy';
// import Terms from './components/terms/Terms';
import Loading from './components/loading/Loading';
import ErrorScreen from './components/loading/ErrorScreen';
import { logo, sanecka } from './components/assets/assets';
import Navigation from './components/navigation/Navigation';
import Login from './components/launch/Login';
import { FETCH_USER_FAILURE, FETCH_USER_REQUEST } from './actions/Types';
import { fetchUser } from './actions/UserActions';
import LoggedInNavigation from './components/navigation/LoggedInNavigation';
import Dashboard from './components/dashboard/Dashboard';
import Artists from './components/artists/Artists';
import Artist from './components/artists/Artist';
import ProtectedRoutes from './components/protectedRoutes/ProtectedRoutes';
import Home from './components/home/Home';
import NotFound from './components/notFound/NotFound';
import TalentSearch from './components/talentSearch/TalentSearch';
import TalentSearchRequests from './components/talentSearch/TalentSearchRequests';
import { fetchTalentSearchRequests } from './actions/TalentSearchActions';
import Logs from './components/logs/Logs';
import RegisterStaff from './components/launch/RegisterStaff';
import MasterCodes from './components/launch/MasterCodes';
import User from './components/profile/User';
import ChangePassword from './components/profile/ChangePassword';
import { fetchArtists } from './actions/ArtistsActions';
import { fetchAnalyticsData } from './actions/AnalyticsActions';
// import ProtectedRoutes from './components/authorization/ProtectedRoutes';
// import DeleteAccount from './components/deleteAccount/DeleteAccount';


// const Home = lazy(() => import('./components/home/Home'));

// const NotFound = lazy(() => import('./components/notFound/NotFound'));



const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);


// Initialize Analytics and get a reference to the service
export const analytics = getAnalytics(app);
logEvent(analytics, 'page_view');

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

const App = () => {
  const dispatch = useDispatch();

  const [isSlow] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(null);


  // const user = useSelector((state) => state.user.user);
  // const loading = useSelector((state) => state.user.userLoading);

  const { requests, loading, error } = useSelector(state => state.talentSearch);


  // const [isSlow, setIsSlow] = useState(false);

  // const [user, setUser] = useState(null);
  // const myProfile = useSelector(state => state.auth.myProfile);
  // const { loading, pictures, error } = useSelector(state => state.launch);

  // useEffect(() => {
  //   const unregisterAuthObserver = onAuthStateChanged(auth, user => {
  //     setUser(user ? true : false);
  //   });
  //   return () => unregisterAuthObserver(); // cleanup subscription on unmount

  // }, [dispatch]);


  // Effect to track slow network and set timeout
  // useEffect(() => {
  //   // Set timeout for detecting slow network (e.g., 3 seconds)
  //   const timer = setTimeout(() => {
  //     setIsSlow(true);
  //   }, 3000); // Timeout after 3 seconds

  //   // Clear the timeout if the component loads before the timeout
  //   return () => clearTimeout(timer);
  // }, []);

  // useLayoutEffect(() => {
  //   dispatch(fetchPictures());
  // }, [dispatch]);

  // if (loading) return <Loading />;

  // if (error) return <ErrorScreen />;

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (authUser) => {
      if (authUser) {
        // Fetch user details from Firestore or your database
        dispatch(fetchUser(authUser?.uid));
        setIsLoggedIn(true);
        // console.log(authUser.uid)

        dispatch(fetchAnalyticsData());

        dispatch(fetchTalentSearchRequests());

      } else {
        ///making suere things are cleared
        setIsLoggedIn(false);
        dispatch({
          type: FETCH_USER_REQUEST,
        });
        dispatch({
          type: FETCH_USER_FAILURE,
          payload: "No user authenticated",
        });
      }
    });

    return () => unsubscribe(); // Cleanup on unmount
  }, [dispatch]);


  useEffect(() => {
    const unsubscribe = dispatch(fetchArtists());

    return () => {
      unsubscribe(); // Cleanup listener on unmount
    };
  }, []);


  // const NotFoundComponent = () => (
  //   // <Topbars>
  //   <NotFound />
  //   //   <Footer />
  //   // </Topbars>
  // );
  const SlowLoadingComponent = () => (
    // <Topbars>
    <div className="slow-loading-message">
      <p>It's taking longer than expected to load the content. Please check your internet connection, try again or wait a bit longer!</p>
    </div>
    //   <Footer />
    // </Topbars>
  );
  const CenterPlaceholderComponent = () => (
    // <Topbars>
    <div className='center-placeholder'>
      <img src={sanecka} alt='logo' />
      <div className="center-loading-animation">
      </div>
      {/* <div class="center-loading-dots">
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
</div> */}
    </div>
    // </Topbars>
  );


  if (isLoggedIn === null) {
    return (<CenterPlaceholderComponent />)
  }


  const renderAccess = () => {

    return (
      <div className="mainContainer">
        {/* <Suspense fallback={
          isSlow ? (
            <SlowLoadingComponent />
          ) : (
            <CenterPlaceholderComponent />
          )
        }> */}
        <Routes>
          <Route element={<Navigation />} >
            <Route path='/' element={<Home />} />
            <Route path='/talent' element={<TalentSearch />} />
            <Route path='/kipaji' element={<TalentSearch />} />
            <Route path='/login' element={<Login />} />
            <Route path='/register' element={<RegisterStaff />} />
            {/* <Route path="*" element={<NotFound />} /> */}
          </Route>
          <Route path='/artists/:artistId' element={<Artist />} />
          <Route element={<ProtectedRoutes isLoggedIn={isLoggedIn} />} >
            <Route element={<LoggedInNavigation />} >
              <Route path='/dashboard' element={<Dashboard />} />
              <Route path='/artists' element={<Artists />} />
              <Route path='/requests' element={<TalentSearchRequests />} />
              <Route path='/visits' element={<Logs />} />
              <Route path='/master-codes' element={<MasterCodes />} />
              <Route path='/user' element={<User />} />
              <Route path='/change-password' element={<ChangePassword />} />
            </Route>
          </Route>
          <Route path="*" element={<NotFound />} />
        </Routes>
        {/* </Suspense> */}
      </div>
    );
  };

  return (
    <BrowserRouter>
      {
        // !loading
        // &&
        // pictures
        // &&
        renderAccess()
      }
    </BrowserRouter>
  );
};

export default App;
